import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { getProfileBannerUrl, isCommunitySponsor } from '../../config/r2rCommercialSeller';

import { AvatarLarge, NamedLink } from '../../components';

import CommunitySponsorBadge from './CommunitySponsorBadge';
import ProfileDetails from './ProfileDetails';
import css from './ProfilePageHeader.module.css';

/**
 * Public profile header: banner, avatar, name + Community Sponsor pill, stat boxes.
 * Contact and policies live in the Profile tab.
 *
 * @component
 */
const ProfilePageHeader = props => {
  const {
    user,
    displayName,
    activeListingsCount = 0,
    showItemsSold = false,
    itemsSoldCount = 0,
    showLinkToProfileSettingsPage = false,
    className,
  } = props;

  const bannerUrl = getProfileBannerUrl(user);
  const showSponsor = isCommunitySponsor(user);

  return (
    <header className={classNames(css.root, className)}>
      {bannerUrl ? (
        <div
          className={css.banner}
          style={{ backgroundImage: `url(${bannerUrl})` }}
          role="img"
          aria-hidden
        />
      ) : null}

      <div className={css.headerInner}>
        <div className={classNames(css.identityRow, { [css.identityRowWithBanner]: !!bannerUrl })}>
          <AvatarLarge className={css.avatar} user={user} disableProfileLink />

          <div className={css.identityText}>
            <div className={css.nameRow}>
              <h1 className={css.displayName}>{displayName}</h1>
              {showSponsor ? <CommunitySponsorBadge className={css.sponsorBadge} /> : null}
            </div>
          </div>
        </div>

        {/* Full-width so stat boxes / badges are not squeezed beside the avatar on mobile */}
        <div className={css.metaBlock}>
          <ProfileDetails
            user={user}
            activeListingsCount={activeListingsCount}
            showItemsSold={showItemsSold}
            itemsSoldCount={itemsSoldCount}
          />

          {showLinkToProfileSettingsPage ? (
            <NamedLink className={css.editLink} name="ProfileSettingsPage">
              <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
            </NamedLink>
          ) : null}
        </div>
      </div>
    </header>
  );
};

export default ProfilePageHeader;
